import { PdfTemplate } from "components";
import { RegisterReconcileList } from "../types";
import { cellValuePdf, RowExportTypePdf } from "types";
import moment from "moment";
import { convertNumber } from "utils";

export function ExportPdf(props: {
    data: RegisterReconcileList[]
    filter: {
        dateFrom: string,
        dateTo: string
    },
    title: string,
}) {

    const columns = [
        { header: "NO", key: "no", width: 5 },
        { header: "RCL ID#", key: "rcl_id", width: 20 },
        { header: "BY", key: "by", width: 20 },
        { header: "NEW S. DATE", key: "new_statement_date", width: 20 },
        { header: "LAST RECON. DATE", key: "last_reconcile_date", width: 20 },
        { header: "NEW S. BALANCE", key: "new_statement_balance", width: 20 },
        { header: "LAST S. BALANCE", key: "last_statement_balance", width: 20 },
        { header: "TOTAL DEBET", key: "total_cleared_debet", width: 20 },
        { header: "TOTAL CREDIT", key: "total_cleared_credit", width: 20 },
        { header: "OUT OF BALANCE", key: "out_of_balance", width: 20 },
    ]

    const dataMap: RowExportTypePdf[] = props.data.map((item, index) => ({
        no: index + 1,
        rcl_id: item.reconciliation_code,
        by: item.created_by_name,
        new_statement_date: moment(item.new_statement_date).format("DD/MM/YYYY"),
        last_reconcile_date: moment(item.last_reconciliation_date).format("DD/MM/YYYY"),
        new_statement_balance: numberFormat(item.new_statement_balance),
        last_statement_balance: numberFormat(item.last_statement_balance),
        total_cleared_debet: numberFormat(item.total_cleared_debet),
        total_cleared_credit: numberFormat(item.total_cleared_credit),
        out_of_balance: numberFormat(item.out_of_balance)
    }))

    return (
        <PdfTemplate
            data={dataMap}
            module="FINANCE"
            title={props.title}
            column={columns}
            date={`${moment(props.filter.dateFrom).format('DD/MM/YYYY')} - ${moment(props.filter.dateTo).format('DD/MM/YYYY')}`}
        />
    )
}

function numberFormat(value: number): cellValuePdf {
    return {
        text: value ? convertNumber(value).intoCurrency : '' ,
        style: {
            textAlign: "right"
        }
    }
}